import {ClientDashboardState} from "../store/client_dashboard_state";
import {Reducer} from "redux";
import {
    ClientDashboardAction,
    ClientDashboardActionType, ICallbackGetAllByRecommendProjectListAction
} from "../action/client_dashboard_action";

const initialState: ClientDashboardState = {
    projectList: [],
};

const clientDashboardReducer: Reducer<ClientDashboardState> = (state = initialState, action: ClientDashboardAction): ClientDashboardState => {
    switch (action.type) {
        case ClientDashboardActionType.CALLBACK_GET_ALL_BY_RECOMMEND_PROJECT_LIST: {
            const _action = action as ICallbackGetAllByRecommendProjectListAction;
            if (action.isSuccess) {
                return Object.assign({}, state, {
                    applyClientList: _action.item,
                });
            } else {
                return state;
            }
        }
        default:
            return state;
    }
};

export default clientDashboardReducer;


// WEBPACK FOOTER //
// ./src/presentation/reducer/client_dashboard_reducer.ts